import Tag from './Tag.component';

export default Tag;
